import { z } from 'zod';
import { GuideHttpFehler } from '../guideNetz';
const StandSchema = z.object({ tag: z.string(), gesammelt: z.number().finite().min(0).max(21600000), gestartet: z.number().finite().nullable(), jetzt: z.number().finite(), ziel: z.literal(21600000) });
const AktionSchema = z.object({ aktion: z.enum(['start', 'pause', 'plus15', 'minus15']) }).strict();
export type FokusStand = z.infer<typeof StandSchema>;
/** HTTP boundary: validate both writes and the server's time state before UI use. */
export async function fokuszeitAnfrage(aktion?: 'start' | 'pause' | 'plus15' | 'minus15'): Promise<FokusStand | null> {
  const r = await fetch('/api/control/fokuszeit', { method: aktion ? 'POST' : 'GET', ...(aktion ? { headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(AktionSchema.parse({ aktion })) } : {}), signal: AbortSignal.timeout(8000) });
  if (r.status === 404) return null; // Private feature is unavailable for this user/house.
  if (!r.ok) throw new GuideHttpFehler(r.status);
  return StandSchema.parse(await r.json());
}
